// import { CSSProperties } from "react";

import { CSSProperties } from 'react';

export enum PluginLocation {
    TOP_BAR = 'TOP_BAR'
}

export const PluginTypeMap = {
    call: 'CALL',
    page: 'PAGE',
    chat: 'CHAT',
    translate: 'TRANSLATE'
} as const;

export enum PluginType {
    CALL = 'CALL',
    PAGE = 'PAGE',
    CHAT = 'CHAT',
    TRANSLATE = 'TRANSLATE',
    RIGHT_PANEL = 'RIGHT_PANEL'
}
export interface PluginManifest {
    title: string;
    global?: boolean;
    singleton?: boolean;
    location: PluginLocation;
    pluginId: string;
    src: string;
    uiDefinition: CSSProperties;
}
export interface PluginSettings extends Record<string, any> {
    appToken: string;
}
export interface PluginDefinition {
    manifest: PluginManifest;
    name: string;
    enabled: boolean;
    pluginId: string;
    settings: Record<string, any>;
    pluginType: PluginType;
}

export interface PluginUser {
    id: number;
    fullName: string;
    email: string;
    phone: string;
}

export type PluginTicket = Record<string, any>;
export interface PluginContext {
    tenantId: string;
    username: string;
    ticketKey: string;
    ticket: PluginTicket;
    agent: PluginUser;
    requester: PluginUser;
    token: string;
    initialStatus?: string;
}
